import {SET_PERSONAL_READINGS} from '../actions/types';


const personalReadings = (state = null, action) => {
  switch (action.type) {
    case SET_PERSONAL_READINGS:
      return action.payload;
    default:
      return state;
  }
};

export default personalReadings;